import {Component, Inject, OnDestroy, OnInit, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef} from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {Subscription, timer} from 'rxjs';
import {map, take} from 'rxjs/operators';

export interface AppicSnackBarData {
  message: string;
  duration: number; // seconds; 0 or negative => stays until manually closed
}

@Component({
  selector: 'appic-snackbar',
  standalone: true,
  imports: [CommonModule, MatSnackBarModule, MatProgressSpinnerModule],
  templateUrl: './appic-snackbar.component.html',
  styleUrls: ['./appic-snackbar.component.scss'],
})
export class AppicSnackBarComponent implements OnInit, OnDestroy {
  snackBarRef = inject(MatSnackBarRef);

  tick = 100;
  private sub?: Subscription;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: AppicSnackBarData) {}

  ngOnInit(): void {
    const duration = this.data.duration;
    if (!duration || duration <= 0) {
      return;
    }

    const stepMs = 100;
    const totalSteps = Math.round((duration * 1000) / stepMs);
    this.sub = timer(0, stepMs)
      .pipe(
        map(step => 100 - (step / totalSteps) * 100),
        take(totalSteps + 1),
      )
      .subscribe({
        next: value => (this.tick = Math.max(0, value)),
        complete: () => this.snackBarRef.dismiss(),
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
